import axiosInstance from './axios';
import { CreateProviderDto, UpdateProviderDto } from 'types/paymentProvider';

const BASE_URL = '/admin/payments/providers';

export const paymentProvidersService = {
  getProviders: () => axiosInstance.get(BASE_URL),
  createProvider: (data: CreateProviderDto) => axiosInstance.post(BASE_URL, data),
  updateProvider: (id: number, data: UpdateProviderDto) => axiosInstance.patch(`${BASE_URL}/${id}`, data),
  deleteProvider: (id: number) => axiosInstance.delete(`${BASE_URL}/${id}`),
};
